/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addResume, getResume } from "../../redux/actions/frontendActions/resumeAction";
import Dashboard_top_header from "../utils/Dashboard_top_header";
import Sidebar from "../utils/Sidebar";
const initialState = {
 link:""
};

function DashboardAddResume() {
 const {resume} =useSelector(state => state.Resume)

  const dispatch = useDispatch();
  const [state, setState] = useState(initialState);
  const [sidebarHide, setSidebarHide] = useState(false);
;
  // handle sidebar
  const handleSidebarHideAndShow = (e) => {
    setSidebarHide(!sidebarHide);
  };


  // handle input
  const handleInput = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // handle main form

  const handleForm = (e) => {
    e.preventDefault();
    dispatch(addResume(state))
    window.location.reload()
  };

useEffect(() =>{
  dispatch(getResume())
},[ dispatch])


  return (
    <div className="dashboard-container">
      <div className="navbar-area">
        <Dashboard_top_header
          handleSidebarHideAndShow={handleSidebarHideAndShow}
          sidebarHide={sidebarHide}
        />
      </div>

      <div className="dashboard-main-flex">
        <div className="dashboard-sidebar">
          <Sidebar sidebarHide={sidebarHide} />
        </div>
        <div className="dashboard-item">

          <div className="liks-item">
            <div className="box">
             {
                 resume.length > 0 ? resume.map(re => <a  href={re.link} target="_blank" rel="noreferrer">{re?.link}</a>) : <p>loading....</p>
                
                }
            
            </div>
          </div>
          {/* add blog form  */}

          <div className="dashboard-add-portfolio-wrapper">
            <div className="form-box">
              <h2>Add Resume</h2>
              <form onSubmit={handleForm}>
                <div className="form-group">
                  <input
                    onChange={handleInput}
                    type="text"
                    placeholder="add resume link"
                    name="link"
                    className="form-control"
                  />
                </div>

               
                <div className="form-group button-area">
               
                  <button type="submit">Add Resume</button>
                </div>
              </form>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardAddResume;